import type { ComponentProps } from "react";
import type * as Sentry from "@sentry/react-native";

import { isTRPCError } from "~/utils/is-trpc-error";
import { EmptyState } from "../empty-state";

type TSentryErrorBoundary = ComponentProps<typeof Sentry.ErrorBoundary>;
type FallbackProps = TSentryErrorBoundary["fallback"];

export const PreconditionFallback: FallbackProps = ({ error }) => {
  if (isTRPCError(error) && error.data?.code === "PRECONDITION_FAILED") {
    return (
      <EmptyState
        text={
          "Наразі у даній групі менше користувачів,  ніж статистично безпечно відображати їх дані та результати"
        }
      />
    );
  }

  throw error;
};

export const PreconditionResearchFallback: FallbackProps = ({ error }) => {
  if (isTRPCError(error) && error.data?.code === "PRECONDITION_FAILED") {
    return (
      <EmptyState
        text={
          "Наразі у даному досліджені менше користувачів,  ніж статистично безпечно відображати їх дані та результати"
        }
      />
    );
  }

  throw error;
};
